import {
  ClientCookieAdapter,
  GeneralizedCookieClient,
  GeoLocationApi,
  wrapAxios
} from '@carvana/merch-geolocation';
import { axios, httpWithAuth } from '~/clients';
import COOKIES from '~/constants/cookies';
import {
  CONTACTS,
  GEOLOCATION,
  LOCATION_INFORMATION_FROM_ZIP
} from '~/constants/endpoints';
import { GEOLOCATION_V2 } from '~/server/endpoints';
import BrowserCookies from '~/utilities/BrowserCookies';
import { generateErrorLogger } from '~/utilities/loggers';

export default function getGeolocationApi(): GeoLocationApi {
  const cookieAdapter = new ClientCookieAdapter(window.document);
  const cookieClient = new GeneralizedCookieClient(cookieAdapter);

  return new GeoLocationApi(
    cookieClient,
    {
      contactsApi: CONTACTS,
      contextApi: LOCATION_INFORMATION_FROM_ZIP,
      geolocationApi: GEOLOCATION,
      geolocationV2Api: GEOLOCATION_V2,
      browserCookieId: BrowserCookies.get(COOKIES.browserCookieId),
      onError: generateErrorLogger('get geolocation')
    },
    wrapAxios(axios),
    wrapAxios(httpWithAuth)
  );
}
